// extracted by mini-css-extract-plugin
export default {"ring":"ProcessingImage_ring__fN5wk","pulsing":"ProcessingImage_pulsing__b7lQZ"};